import {
  Image,
  Space,
  Stack,
  Text,
  rem,
  BackgroundImage,
  em,
  Grid,
  Container,
  Box,
  Button,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const Home = () => {
  const isMobile = useMediaQuery(`(max-width: ${em(750)})`);
  const isSuperSmallDevice = useMediaQuery(`(max-width: ${em(450)})`);
  const { eventCode } = useParams();

  useEffect(() => {
    if (eventCode) {
      fetch(
        [
          process.env.REACT_APP_BACKEND_URL,
          "/partner/tracking/event/",
          eventCode,
        ].join("")
      )
        .then((res) => res.json())
        .then((response) => {
          if (response?.data) {
            const { utm_source, utm_medium, utm_campaign, action, actionData } =
              response.data || {};
            tracking(utm_source, utm_medium, utm_campaign, action, actionData);
            handleDirect(eventCode);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [eventCode]);

  const tracking = (
    utm_source,
    utm_medium,
    utm_campaign,
    action,
    actionData
  ) => {
    if (utm_source && utm_medium && utm_campaign) {
      const URL = [
        process.env.REACT_APP_BACKEND_URL,
        "/partner/tracking/event?utm_source=",
        utm_source,
        "&utm_medium=",
        utm_medium,
        "&utm_campaign=",
        utm_campaign,
        "&action=",
        action,
        "&actionData=",
        actionData,
      ].join("");
      fetch(URL);
    }
  };

  const handleDirect = () => {
    const userAgent = navigator.userAgent;
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );
    if (isMobile) {
      window.location =
        process.env.REACT_APP_DEEPLINK_SCHEMA +
        "://app?action=tracking&eventCode=" +
        eventCode;
      const to = setTimeout(() => {
        if (document.visibilityState === "hidden") {
          clearTimeout(to);
          return;
        }
        // detect iOS
        const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
        if (isIOS) {
          window.location = "https://apps.apple.com/app/igourmet/id6478311173";
        } else {
          // For Android or other devices, redirect to another URL or handle differently
          window.location =
            "https://play.google.com/store/apps/details?id=vn.takahiro.igourmet";
        }
      }, 4000);
    } else {
      // fallback
      // window.location = "";
    }
  };
  return (
    <Container miw={400} px={(isMobile || isSuperSmallDevice) && 35}>
      <BackgroundImage src="assets/home-bg.png" fit="cover">
        <Stack align="center" justify="center" gap="md" pt="xl">
          <Image
            src={"assets/logo-title.png"}
            alt="Mantine logo"
            fit="scale-down"
            w={"30%"}
          />
          <Image
            src={"assets/slogan-header.png"}
            alt="Mantine logo"
            fit="scale-down"
          />
        </Stack>
        <Box mt={rem(20)}>
          <Stack
            gap="md"
            align="flex-end"
            justify="flex-start"
            px="md"
            pt={rem(isSuperSmallDevice ? 30 : 80)}
            pos="relative"
          >
            <Image
              src="assets/sphone.png"
              fit="scale-down"
              pos="absolute"
              w="80%"
              left={0}
              top={0}
            />
            <BackgroundImage
              p="md"
              radius="md"
              src="assets/background-text.png"
              maw="70%"
            >
              <Text align="right" c="white" size={rem(isMobile ? 12 : 24)}>
                Chuyển đổi thẻ thành viên qua
                <br />
                ứng dụng <b>iGOurmet</b>
              </Text>
            </BackgroundImage>
            <Image
              src={"assets/slogan-text.png"}
              fit="scale-down"
              w="40%"
              py="xs"
              h={20}
            />
          </Stack>

          <Grid>
            <Grid.Col span={6} />
            <Grid.Col span={6}>
              <Box align="center">
                <Button
                  onClick={handleDirect}
                  style={{
                    padding: 0,
                    backgroundColor: "transparent",
                    border: "none",
                    height: rem(60),
                  }}
                >
                  <Image
                    src="assets/btn-open-app.png"
                    fit="scale-down"
                    mah={rem(90)}
                    maw={rem(isMobile ? 160 : 300)}
                  />
                </Button>
                <Box p="md" radius="md" w="60%">
                  <Image src="assets/appstore-download.png" fit="scale-down" />
                  <Space h="xs" />
                  <Image src="assets/chplay-download.png" fit="scale-down" />
                </Box>
              </Box>
            </Grid.Col>
          </Grid>
        </Box>
        <Space h={rem(isMobile || isSuperSmallDevice ? 70 : 300)} />
        <Image src="assets/wave-content.png" fit="scale-down" w="100%" />
        <Space h={50} />
        <Text
          align="center"
          c="primary"
          fw="bold"
          size={rem(isMobile || isSuperSmallDevice ? 10 : 18)}
          style={{
            textTransform: "uppercase",
          }}
        >
          Hưởng trọn ưu đãi với nhiều voucher độc quyền từ các chuỗi nhà hàng
          lớn
        </Text>
        <Space h={10} />
        <Image
          src="assets/footer-brands.png"
          fit="scale-down"
          bg="white"
          px="sm"
          radius="xs"
        />
      </BackgroundImage>
      <Space h={50} />
    </Container>
  );
};
export default Home;
